const styles = theme => ({
    root: {
        flexGrow: 1,
        // padding: theme.spacing.unit * 10,
        paddingTop: '10px',
        maxWidth: '1475px',
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            // margin: 8
        },
    },
    drawerHeader: {
        paddingLeft: '88px'
    },
    fontFamily: theme.typography.fontFamily,
    control: {
        padding: theme.spacing.unit * 2
    },
    logo: {
        height: '60px'
    },
    logoMobile: {
        height: '45px',
        padding: '10px 0px 0px 10px'
    },
    padding: {
        padding: '20px'
    },
    headline: {
        fontSize: '24px',
        color: theme.palette.secondary.dark,
        marginBottom: '50px',
        [theme.breakpoints.down('sm')]: {
            padding: '0 25px 15px',
            margin: '15px 0',
            color: theme.palette.common.black,
            fontWeight: '500',
            fontSize: '15px'
        }
    },
    teetimeGrid: {
        paddingLeft: '10px'
    },
    datepicker: {
        border: `1px solid #d5d8db`,
        width: 'auto',
        margin: '-1px 0',
        marginBottom: '40px',
        borderRadius: '3px',
        [theme.breakpoints.down('sm')]: {
            margin: 0,
            borderBottom: `1px solid #d5d8db`,
            width: '100%'
        }
    },
    calendar: {
        height: '20px'
    },
    mobileCalander: {
        height: '17px'
    },
    date: {
        margin: '0 auto'
    },
    expand: {
        color: theme.palette.primary.main,
        fontSize: '20px'
    },
    mobileExpand: {
        color: theme.palette.primary.main,
        fontSize: '14px',
        marginLeft: '10px'
    },
    expansion: {
        display: 'inherit',
        padding: 0,
        borderTop: '2px solid #EDEDED',
        [theme.breakpoints.down('sm')]: {
            borderTop: '1px solid #d5d8db'
        },
    },
    closeButton: {
        left: '100px',
        position: 'relative',
        top: '-10px',
        fontSize: '30px',
        cursor: 'pointer',
        color: '#A5A8Ab'
    },
    closeButtonMobile: {
        marginTop: '10px',
        position: 'relative',
        fontSize: '30px',
        cursor: 'pointer',
        color: theme.palette.primary.main
    },
    dateSelected: {
        marginLeft: '25px',
        fontSize: '14px',
        color: theme.grouponHeadingColor,
        fontWeight: 600,
},
    paper: {
        position: 'absolute',
        width: '683px',
        textAlign: 'center',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
        paddingBottom: 0,
        borderRadius: '3px'
    },
    modalHeader: {
        color: '#333',
        fontWeight: 100
    },
    modalButton: {
        padding: '0 35px',
        fontSize: '14px',
        fontWeight: 600,
        minHeight: '40px',
        textTransform: 'inherit',
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark
        },
        color: theme.palette.common.white
    },
    modalBody:{
        color: '#75787B'
    },
    center: {
        margin: '30px 0 55px 0'
    },
    select: {
        border: '1px solid #979797',
        padding: '20px 30px',
        borderRadius: '3px',
        color: '#898c90',
        '&:hover:not($disabled):not($focused):not($error):before': {
            borderBottom: '1px solid rgba(0, 0, 0, 0.42)'
        },
        '&:after': {
            borderBottom: '1px solid rgba(0, 0, 0, 0.42)'
        }
    },
    disabled: {},
    focused: {},
    error: {},
    selectDialog: {
        border: '1px solid #979797',
        padding: '7px 15px',
        borderRadius: '3px'
    },
    mobileEach: {
        display: 'none',
        position: 'absolute',
        right: '25px',
        marginTop: '2px',
        fontSize: '13px',
        [theme.breakpoints.down('sm')]: {
            display: 'block'
        }
    },
    mobileEachDialog: {
        fontSize: '18px',
        fontWeight: '500',
        display: 'block',
        position: 'absolute',
        right: '25px'
    },
    ea: {
        fontSize: '13px',
        color: theme.palette.primary.main
    },
    teePriceDialog: {
        color: theme.palette.primary.light,
        marginLeft: '7px',
        fontSize: '18px',
        fontWeight: 'bold'
    },
    amountSelect: {
        display: 'inline-block',
        marginLeft: '10px'
    },
    payWrapper: {
        padding: '20px',
        borderTop: '1px solid #d5d8db'
    },
    buttonDialog: {
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark
        },
        color: theme.palette.common.white,
        fontWeight: 600,
        fontSize: '12px',
        padding: 0
    },
    buttonGrid: {
        'text-align': 'right'
    },
    strike: {
        textDecoration: 'line-through',
        color: theme.palette.secondary.light
    },
    pricesDialog: {
        fontSize: '18px',
        display: 'inline-block',
        fontWeight: 500
    },
    detailDialogHoles: {
        marginLeft: '10px',
        fontSize: '16px',
        color: theme.palette.secondary.dark
    },
    detailDialog: {
        fontSize: '16px',
        color: theme.palette.secondary.dark
    },
    borderBottom: {
        borderBottom: '1px solid #d5d8db',
        padding: '25px',
        [theme.breakpoints.down('sm')]: {
            cursor: 'pointer'
        }
    },
    iconsDialog: {
        width: '20px',
        height: '20px',
        marginLeft: '10px',
        position: 'relative',
        top: '6px',
    },
    mobileBookDialog: {
        fontFamily: theme.typography.fontFamily
    },
    drawer: {
        borderRadius: '10px 10px 0px 0px',
        height: '50%'
    },
    drawerHeaderContainer: {
        height: 58
    },
    teeIcon: {
        height: '20px',
        marginTop: '3px'
    },
    mobileTeeIcon: {
        height: '17px',
        marginTop: '3px'
    },
    modalTeeIcon: {
        height: '100px',
        fontSize: '50px'
    },
    mobileHeader: {
        color: '#333',
        textTransform: 'none',
        fontSize: '14px'
    },
    filterIcon: {
        display: 'none',
        [theme.breakpoints.down('sm')]: {
          display: 'inline-flex',
          cursor: 'pointer',
        //   paddingRight: '42px',
          paddingTop: '3px'
        }
      },
      mobileTabs: {
          padding: 0,
          borderRadius: 0,
          width: '100%',
          height: '53px'
      },
      border: {
        borderBottom: '1px solid #d5d8db'
      },
      tabBorder: {
        // this may need to be changed
        borderLeft: `1px solid #d5d8db`
    },
    mobileLoadMore: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    mobileLoadMoreButton: {
        color: theme.palette.primary.main,
        textTransform: 'none'
    },
    drawerTitle: {
        color: theme.grouponBlack,
        fointSize: 16
    },
    drawerActionButtons: {
        color: theme.palette.primary.main,
        fontSize: 14
    },
    minW100: {
        minWidth: '100%',
        maxWidth: '100%'
    },
    unsetTextTransform: {
        textTransform: 'none'
    },
    primaryColor: {
        color: theme.palette.primary.main
    },
    centerize: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    paddingTop5: {
        paddingTop: '5px'
    },
    semiBold: {
        fontWeight: 600
    },
    mobileModalBody: {
        fontSize: '16px',
        color: '#333'
    },
    mobileButtons: {
        color: '#531318',
        minHeight: '45px',
        height: '45px',
        minWidth: '45px',
        padding: '25px',
        '&:active': {
            backgroundColor: theme.palette.primary.main
        }
    },
    progress: {
        color: theme.palette.primary.main
    },
    alertText: {
        color: '#FF2552',
        fontSize: '20px',
        [theme.breakpoints.down('sm')]: {
            fontSize: 15,
            marginTop: 5,
            marginBottom: 5,
        }
    },
    alertTextContainer: {
        [theme.breakpoints.down('sm')]: {
            border: '1px solid #d5d8db',
        }
    }
});

export default styles;


// WEBPACK FOOTER //
// ./src/containers/TeeTimesSearch/styles.js